<template>
  <div>
    <div class="text-xs text-gray-600 uppercase mb-1">{{ option.description }}</div>
    <div v-if="option.unit == 'time'" class="text-xl">{{ value }}</div>
    <div v-else-if="option.unit == 'financial'" class="text-xl relative">
      <span
        v-if="value"
        class="absolute text-gray-500 pointer-events-none"
      >{{ settings.currency }}</span>
      <span
        v-if="value"
        class="pl-4"
      >{{ value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</span>
    </div>
    <div v-else-if="option.unit == 'percentage'" class="text-xl relative">
      <span
        v-if="value"
        class="pr-4 inline-block w-full text-right"
      >{{ value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</span>
      <span
        v-if="value"
        class="absolute right-0 text-gray-500 pointer-events-none"
      >%</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PriceSummaryItem',
  props: {
    editable: Boolean,
    option: Object,
    value: Number,
    model: Object,
    settings: Object
  }
};
</script>
